import { objectSchema } from "vue-utils"

export interface LatLng {
	latitude: number
	longitude: number
}

export const LatLng = objectSchema<LatLng>({
	latitude: Number,
	longitude: Number,
})
